import { createRoot } from 'react-dom/client';
import ErrorBoundaryApp from 'components/base-elements/error-boundaries/ErrorBoundaryApp';
import { Provider } from 'react-redux';
import { store } from '@store/store';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import loadTranslations from '@translations/functions';
import AuthComponent from '@features/authentication/AuthComponent';
import { RouterProvider } from 'react-router';
import { router } from '@features/routing/createRouter';
import '@styles/main.scss';



const Root = () => {
	loadTranslations();

	return (
		<ErrorBoundaryApp>
			<Provider store={store}>
				<I18nextProvider i18n={i18next}>
					<AuthComponent />
					<RouterProvider router={router} />
				</I18nextProvider>
			</Provider>
		</ErrorBoundaryApp>
	);
};

const root = createRoot(document.getElementById('root')!);
root.render(<Root />);